import { HttpInterceptorFn } from '@angular/common/http';

export const cacheBusterInterceptor: HttpInterceptorFn = (req, next) => {
  const cacheReq = req.clone({
    setHeaders: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  });

  return next(cacheReq);
};